import {createRouter, createWebHistory} from 'vue-router';
import {isAuthenticated} from '../services/auth';

const Login = () => import('../components/dashboard/Login.vue');
const BookingIndex = () => import('../components/booking/BookingIndex.vue');
const CancelBooking = () => import('../components/booking/CancelBooking.vue');
const Account = () => import('../components/dashboard/Account.vue');
const RescheduleBooking = () => import('../components/booking/RescheduleBooking.vue');
const PasswordRequest = () => import('../components/dashboard/PasswordRequest.vue');
const PasswordReset = () => import('../components/dashboard/PasswordReset.vue');
const Appointments = () => import('../components/dashboard/Appointments.vue');
const CalDavAuthsList = () => import('../components/dashboard/CalDavAuth/CalDavAuthsList.vue');
const EventTypeList = () => import('../components/dashboard/EventType/EventTypeList.vue');
const Availabilities = () => import('../components/dashboard/Availability/Availabilities.vue');
const CalDavSyncLog = () => import('../components/dashboard/CalDavAuth/CalDavSyncLog.vue');
const AdminIndex = () => import('../components/dashboard/admin/AdminIndex.vue');
const AdminUsers = () => import('../components/dashboard/admin/user/AdminUsers.vue');
const AuditLog = () => import('../components/dashboard/admin/AuditLog.vue');

const routes = [
    // Chris 02.11.2026: Die Startadresse oeffnet direkt "Intensives Gespraech"; die Uebersicht aller Terminarten steht unter /termin.
    {
        name: 'start',
        path: '/',
        redirect: '/termin/45minuten',
    },
    {
        name: 'login',
        path: '/dashboard/login',
        component: Login,
        meta: { title: 'login.headline' }
    },
    {
        name: 'password_request',
        path: '/password/request',
        component: PasswordRequest,
        meta: { title: 'password_request.headline' }
    },
    {
        name: 'password_reset',
        path: '/password/reset/:token/:email',
        component: PasswordReset,
        meta: { title: 'password_reset.headline' }
    },
    {
        name: 'public_booking',
        path: '/termin/:event_type_slug?',
        component: BookingIndex,
        meta: { title: 'booking.form.headline' }
    },
    {
        name: 'booking_index',
        path: '/:email/:event_type_slug?',
        component: BookingIndex,
        meta: { title: 'booking.form.headline' }
    },
    {
        name: 'reschedule_booking',
        path: '/event/:id/reschedule/:hash',
        component: RescheduleBooking,
        meta: { title: 'booking.reschedule.headline' }
    },
    {
        name: 'cancel_booking',
        path: '/event/:id/cancel/:hash',
        component: CancelBooking,
        meta: { title: 'booking.cancel.headline' }
    },
    {
        name: 'dashboard',
        path: '/dashboard',
        component: Appointments,
        meta: {requiresAuth: true, title: 'dashboard.appointments.index.headline'}
    },
    {
        name: 'account',
        path: '/dashboard/account',
        component: Account,
        meta: {requiresAuth: true, title: 'account.headline'}
    },
    {
        name: 'caldav_auths',
        path: '/dashboard/account/caldav',
        component: CalDavAuthsList,
        meta: {requiresAuth: true, title: 'account.caldav_auths.headline'}
    },
    {
        name: 'caldav_auth_log',
        path: '/dashboard/account/caldav/log',
        component: CalDavSyncLog,
        meta: {requiresAuth: true, title: 'account.caldav_auths.logs.headline'}
    },
    {
        name: 'event_types',
        path: '/dashboard/event_types',
        component: EventTypeList,
        meta: {requiresAuth: true, title: 'account.event_types.headline'}
    },
    {
        name: 'dashboard_availability',
        path: '/dashboard/availability',
        component: Availabilities,
        meta: {requiresAuth: true, title: 'account.availability.headline'}
    },
    {
        name: 'admin_index',
        path: '/dashboard/admin',
        component: AdminIndex,
        meta: {requiresAuth: true, title: 'dashboard.admin.index.headline'}
    },
    {
        name: 'admin_users',
        path: '/dashboard/admin/users',
        component: AdminUsers,
        meta: {requiresAuth: true, title: 'dashboard.admin.users.headline'}
    },
    {
        name: 'admin_audit_log',
        path: '/dashboard/admin/audit-log',
        component: AuditLog,
        meta: {requiresAuth: true, title: 'dashboard.admin.audit_logs.headline'}
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !isAuthenticated()) {
        next('/dashboard/login');
    } else {
        next();
    }
});

export default router;
